import { expertise } from "@/data/content";
import { SectionHeading, Reveal } from "@/components/motion";

export const Expertise = () => (
  <section id="expertise" className="bg-white border-y border-slate-200/70 py-16 sm:py-24 lg:py-32" data-testid="expertise-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="02"
        eyebrow="Areas of Expertise"
        title="Specialist Care Across Internal Medicine"
        sub="From everyday illnesses to long-term conditions — each concern is evaluated thoroughly and managed with evidence-based care."
      />
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="expertise-grid">
        {expertise.map((item, i) => (
          <Reveal key={item.title} delay={i % 3}>
            <article
              data-testid={`expertise-card-${item.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group h-full bg-slate-50/60 rounded-2xl border border-slate-200/80 p-6 sm:p-7 hover:-translate-y-1 hover:shadow-lift hover:bg-white hover:border-teal-500/30 transition-[transform,box-shadow,background-color,border-color] duration-300"
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-xl bg-white border border-slate-200 shadow-soft flex items-center justify-center group-hover:bg-teal-600 group-hover:border-teal-600 transition-colors duration-300">
                  <item.icon size={20} className="text-navy-900 group-hover:text-white transition-colors duration-300" />
                </div>
                <span className="font-mono text-xs text-slate-300 group-hover:text-teal-500 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-5 font-serif font-semibold text-slate-900 text-xl leading-snug">{item.title}</h3>
              <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{item.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
